import { useAppDispatch } from '@/store/hooks';
import { usePaymentsConfig } from '@/services/paymentsConfig/usePaymentsConfig';
import PaypalButton from '@/providers/paypal/PaypalButton';
import GooglepayButton from '@/providers/braintreeGooglepay/GooglepayButton';
import ApplepayButton from '@/providers/braintreeApplepay/ApplepayButton';

import { setProvider, ProviderName } from './paymentSelectSlice';
import CardPaymentButton from './CardPaymentButton';

import {
  PaymentButtonsSingleSection,
  PaymentButtonRow,
  PaymentButtonRowInner
} from './PaymentSelect.style';

export const singleProviderConfigs = [
  {
    name: 'STRIPE',
    Component: CardPaymentButton,
    label: 'Pay by Card',
    testId: 'paymentSelectCard'
  },
  {
    name: 'BRAINTREE',
    Component: CardPaymentButton,
    label: 'Pay by Card',
    testId: 'paymentSelectCard'
  },
  {
    name: 'PAYPAL',
    Component: PaypalButton,
    testId: 'paymentSelectPaypal'
  },
  {
    name: 'BRAINTREE_GOOGLEPAY',
    Component: GooglepayButton,
    testId: 'paymentSelectGooglepay'
  },
  {
    name: 'BRAINTREE_APPLEPAY',
    Component: ApplepayButton,
    testId: 'paymentSelectApplepay'
  },
];

function ProviderSelectSingle({
  setProcessing
}: {
  setProcessing: (newProcessing: boolean) => void,
}) {
  const dispatch = useAppDispatch();

  const { isProviderAvailable } = usePaymentsConfig();

  const providerGroup = 'single';

  const handleProviderSelect = (provider: ProviderName) => {
    dispatch(setProvider(provider));
  };

  return (
    <PaymentButtonsSingleSection>
      {singleProviderConfigs.map(({
        name, Component, label, testId
      }) => isProviderAvailable(providerGroup, name) && (
        <PaymentButtonRow key={name}>
          <PaymentButtonRowInner>
            <Component
              onClick={() => handleProviderSelect(name as ProviderName)}
              setProcessing={setProcessing}
              testId={testId}
            >
              {label}
            </Component>
          </PaymentButtonRowInner>
        </PaymentButtonRow>
      ))}
    </PaymentButtonsSingleSection>
  );
}

export default ProviderSelectSingle;
